import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Linkedin, Twitter, Instagram } from "lucide-react";
import { SERVICES, STATES, FIRM } from "../data/siteData";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative overflow-hidden bg-brand-navy text-white">
      <div className="blob blob-float left-[-10%] top-[-20%] h-96 w-96 bg-brand-blue/25" />
      <div className="blob blob-float-slow bottom-[-30%] right-[-5%] h-[28rem] w-[28rem] bg-brand-sky/15" />
      <div className="relative mx-auto max-w-7xl px-4 py-16 sm:px-6">
        <div className="grid gap-10 lg:grid-cols-12">
          <div className="lg:col-span-3">
            <Link to="/" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-gradient-to-br from-brand-blue to-brand-sky font-display text-lg font-extrabold text-white">C</span>
              <span className="font-display text-lg font-bold">Complisure <span className="text-brand-sky">Counsultancy</span></span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-white/60">
              CA, CS & Legal advisory for startups and growth companies — from incorporation to growth-stage fundraising rounds, across 31 cities in India.
            </p>
            <div className="mt-5 space-y-2.5 text-sm text-white/70">
              <a href={`tel:${FIRM.phoneRaw}`} data-testid="footer-phone" className="flex items-center gap-2 hover:text-brand-sky"><Phone className="h-4 w-4 text-brand-sky" /> {FIRM.phoneDisplay}</a>
              <a href={`mailto:${FIRM.email}`} data-testid="footer-email" className="flex items-center gap-2 hover:text-brand-sky"><Mail className="h-4 w-4 text-brand-sky" /> {FIRM.email}</a>
              <p className="flex items-start gap-2"><MapPin className="mt-0.5 h-4 w-4 shrink-0 text-brand-sky" /> {FIRM.address}</p>
            </div>
            <div className="mt-5 flex gap-3">
              {[Linkedin, Twitter, Instagram].map((Ico, i) => (
                <a key={i} href="#" aria-label="Social link" data-testid={`footer-social-${i}`} className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 transition-colors hover:bg-brand-blue">
                  <Ico className="h-4 w-4" />
                </a>
              ))}
            </div>
            <div className="mt-6 flex flex-wrap gap-2">
              {["ICAI Members", "ICSI Members", "Bar Council", "IBBI Valuers"].map((b) => (
                <span key={b} className="rounded-full border border-white/15 bg-white/5 px-3 py-1 text-[11px] font-medium text-white/70">{b}</span>
              ))}
            </div>
          </div>

          <div className="lg:col-span-3">
            <h3 className="mb-4 text-xs font-semibold uppercase tracking-[0.18em] text-brand-sky">Services</h3>
            <ul className="space-y-2">
              {SERVICES.map((s) => (
                <li key={s.slug}>
                  <Link to={`/services/${s.slug}`} data-testid={`footer-service-${s.slug}`} className="text-sm text-white/60 transition-colors hover:text-white">{s.name}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <h3 className="mb-4 text-xs font-semibold uppercase tracking-[0.18em] text-brand-sky">Locations</h3>
            <div className="grid grid-cols-2 gap-x-6 gap-y-4">
              {STATES.map((st) => (
                <div key={st.slug}>
                  <Link to={`/locations/${st.slug}`} data-testid={`footer-state-${st.slug}`} className="text-sm font-semibold text-white hover:text-brand-sky">{st.name}</Link>
                  <ul className="mt-1.5 space-y-1">
                    {st.cities.map((c) => (
                      <li key={c.slug}>
                        <Link to={`/locations/${st.slug}/${c.slug}`} className="text-xs text-white/50 transition-colors hover:text-white">{c.name}</Link>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-2">
            <h3 className="mb-4 text-xs font-semibold uppercase tracking-[0.18em] text-brand-sky">Company</h3>
            <ul className="space-y-2 text-sm text-white/60">
              <li><Link to="/about" data-testid="footer-about" className="hover:text-white">About Us</Link></li>
              <li><Link to="/industries" data-testid="footer-industries" className="hover:text-white">Industries</Link></li>
              <li><Link to="/valuation-fundraising" data-testid="footer-valuation" className="hover:text-white">Valuation & Fundraising</Link></li>
              <li><Link to="/case-studies" data-testid="footer-cases" className="hover:text-white">Case Studies</Link></li>
              <li><Link to="/blog" data-testid="footer-blog" className="hover:text-white">Resources & Blog</Link></li>
              <li><Link to="/careers" data-testid="footer-careers" className="hover:text-white">Careers</Link></li>
              <li><Link to="/contact" data-testid="footer-contact" className="hover:text-white">Contact</Link></li>
              <li><a href="/api/sitemap.xml" data-testid="footer-sitemap" className="hover:text-white">Sitemap</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-white/10 pt-6 text-xs text-white/40 sm:flex-row">
          <p>© {new Date().getFullYear()} {FIRM.name}. All rights reserved.</p>
          <p>Incorporation to IPO-ready — compliance that compounds.</p>
        </div>
      </div>
    </footer>
  );
}
